// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__H5ozE","checkbox__label":"checkbox_checkbox__label__khEKP","checkbox__error":"checkbox_checkbox__error__Kd646"};